import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58bae066"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-wrapper__wrap" }

import { ComponentPublicInstance, ref, onMounted, onUnmounted } from "vue";
import CustomScrollbar from "@/components/custom-scrollbar/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {

const dropdownScrollRef = ref<ComponentPublicInstance<HTMLElement>>();
const dropdownRef = ref<ComponentPublicInstance<HTMLElement>>();
const height = ref<number>(0);

__expose({ dropdownScrollRef, dropdownRef });

onMounted(() => {
  window.addEventListener("resize", onResize);
  setTimeout(() => {
    onResize();
  }, 100);
});
onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});

const onResize = () => {
  if (dropdownRef.value) {
    const topOffset = (dropdownRef.value as HTMLElement).getBoundingClientRect()
      .top;
    const windowHeight = window.screen.height;
    const bottomOffset = 32;

    height.value = windowHeight - (topOffset + bottomOffset);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: "dropdown-wrapper",
    style: _normalizeStyle({ maxHeight: height.value + 'px' })
  }, [
    _createVNode(CustomScrollbar, {
      ref_key: "dropdownScrollRef",
      ref: dropdownScrollRef,
      class: "dropdown-wrapper__scroll-area",
      style: _normalizeStyle({ maxHeight: height.value - 16 + 'px' })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["style"])
  ], 4))
}
}

})